import { render, staticRenderFns } from "./fsBlockEquity.vue?vue&type=template&id=72912864"
import script from "./fsBlockEquity.vue?vue&type=script&lang=js"
export * from "./fsBlockEquity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports